import { Vehicle } from "src/types/loan-application";
import useTitleCase from "./use-title-case";

export default function sanitiseVehicleFailReason(vehicle: Vehicle, reason: string) {
    if(reason === "Vehicle is excluded") return `${vehicle.make.length! > 3 ? useTitleCase(vehicle.make!) : vehicle.make} is not financed`;
    if(reason === "Vehicle age" || reason === "Vehicle age at end of term" || reason.includes(" age exceeds")) return "Vehicle too old";
    if(reason.includes("max mileage") || reason.includes("mileage exceeds")) return "Mileage too high"; 
    if(reason.includes("Loan amount exceeds")) return `Loan > ${reason.split(" ")[reason.split(" ").length - 1]}`;
    if(reason.includes("does not meet min")) return `Loan < ${reason.split(" ")[reason.split(" ").length - 1]}`;
    return reason;
}